(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["venture-parallax"] && !Shopify.designMode) return;
  try {
    /*
 * Sticky-stack scroll effect for venture sections.
 *
 * Each `.shopify-section.venture-section` (except the hero) is pinned via
 * `position: sticky` (venture-global.css). The background (`.venture-stack__bg`)
 * drifts up slowly the whole time the section is on screen so it looks almost
 * fixed, while the content (`.venture-stack__content`) scrolls up past it at
 * full speed — symmetrically on entrance (climbing in) and exit (being covered).
 * Drift amount comes from `data-parallax-strength` (0 = fixed, 100 = fastest),
 * a fixed value baked into each section's markup (no longer merchant-tunable).
 *
 * Background and content transforms are driven by a shared ScrollTimeline
 * (Web Animations API) so they update on the compositor during scroll instead of
 * via per-frame main-thread style writes — which eliminates background drift
 * stutter. Sections that use the mobile “whole block” layout still use a light
 * scroll listener for `.venture-stack__mobile-unit` only.
 */
(function () {
  // Scales strength % down so even 100% keeps the background slower than the content.
  const DRIFT_SCALE = 0.4;

  // Mobile-unit sections (media-with-card) keep their stacked layout: the media
  // is a block at the top, then the card. The block can't pin, so instead the
  // image pans gently *inside* its (clipped) frame as the block transits the
  // viewport — trailing the scroll by this fraction so it reads slower than the
  // card. MOBILE_MEDIA_HEADROOM is the px of slack the image has on each side to
  // pan into; it must match the overflow built into the CSS.
  const MOBILE_MEDIA_LAG = 0.15;
  const MOBILE_MEDIA_HEADROOM = 120;

  let sectionEntries = [];
  let listenersBound = false;
  let scrollFrameQueued = false;
  let measureScheduled = false;
  let jsScrollNeeded = false;
  let scrollTimeline = null;
  // Signature of the geometry the compositor animations were last built from.
  // Re-measuring (resize, late media, ResizeObserver, the mobile URL bar) only
  // rebuilds the animations when this actually changes — cancelling/recreating
  // them mid-scroll otherwise would cause visible hitches.
  let lastBindSignature = null;
  // Some sections lay out differently on mobile (e.g. media-with-card stacks the
  // media above the card instead of overlaying it). There the bg/content split
  // makes no sense, so the whole section travels as one `mobile unit` instead.
  const mobileMediaQuery = window.matchMedia('(max-width: 1000px)');

  function supportsScrollTimeline() {
    return typeof ScrollTimeline !== 'undefined';
  }

  function getScrollTimeline() {
    if (!scrollTimeline && supportsScrollTimeline()) {
      scrollTimeline = new ScrollTimeline({
        source: document.scrollingElement,
        axis: 'block'
      });
    }
    return scrollTimeline;
  }

  function getMaxScroll() {
    const scrollingElement = document.scrollingElement;
    return Math.max(1, scrollingElement.scrollHeight - scrollingElement.clientHeight);
  }

  function scrollFraction(scrollPosition, maxScroll) {
    if (maxScroll <= 0) {
      return 0;
    }
    const fraction = scrollPosition / maxScroll;
    if (fraction < 0) {
      return 0;
    }
    if (fraction > 1) {
      return 1;
    }
    return fraction;
  }

  function documentTop(element) {
    let top = 0;
    let node = element;
    while (node) {
      top += node.offsetTop;
      node = node.offsetParent;
    }
    return top;
  }

  // Cancel every scroll-driven animation we may have attached to an element.
  // The compositor refuses to run an element whose transform is driven by more
  // than one animation, so it would fall back to the main thread and the layer
  // would lag (shake) behind the compositor's async scroll. Tracking a single
  // handle isn't enough on its own — re-inits/HMR can leave strays — so we sweep
  // every ScrollTimeline-backed animation on the node to guarantee exactly one.
  function cancelScrollAnimations(element) {
    if (!element || typeof element.getAnimations !== 'function') {
      return;
    }
    element.getAnimations().forEach(function (animation) {
      const timeline = animation.timeline;
      if (timeline && timeline.constructor && timeline.constructor.name === 'ScrollTimeline') {
        animation.cancel();
      }
    });
  }

  function clearAnimations(entry) {
    if (entry.backgroundAnimation) {
      entry.backgroundAnimation.cancel();
      entry.backgroundAnimation = null;
    }
    if (entry.contentAnimations) {
      entry.contentAnimations.forEach(function (animation) {
        animation.cancel();
      });
      entry.contentAnimations = null;
    }
    if (entry.background) {
      cancelScrollAnimations(entry.background);
      entry.background.style.transform = '';
    }
    entry.contentNodes.forEach(function (contentNode) {
      cancelScrollAnimations(contentNode);
      contentNode.style.transform = '';
    });
  }

  function bindScrollAnimations(entry, viewportHeight, maxScroll, timeline) {
    clearAnimations(entry);

    const top = entry.top;
    const height = entry.height;
    const drift = entry.drift;
    const toFraction = function (scrollPosition) {
      return scrollFraction(scrollPosition, maxScroll);
    };

    if (entry.background) {
      // The background drifts up at one constant *screen-space* speed the whole
      // time the section is on screen (entrance + exit), so the motion never
      // changes pace as the section pins. The speed (`drift`) is gentle — a
      // fraction of the scroll — so it always lags the content.
      //
      // It is anchored so the background is vertically centered in the viewport
      // at the instant the section is fully revealed (scroll == top). Because
      // backgrounds are usually taller than the viewport, `centerOffset` shifts
      // the layer up by half the overflow so "centered" is exact rather than
      // top-aligned. Clamped to <= 0 so a background shorter than the viewport
      // is never pushed down to reveal a gap.
      const backgroundHeight = entry.backgroundHeight || viewportHeight;
      let centerOffset = (viewportHeight - backgroundHeight) / 2;
      if (centerOffset > 0) {
        centerOffset = 0;
      }

      // Entrance (scroll: top-vh -> top): the section climbs up at full speed,
      // so cancel (1 - drift) of that to leave only the gentle drift on screen.
      // Below by `drift * vh` at first, reaching the centered anchor at the pin.
      const backgroundEnter = centerOffset - viewportHeight * (1 - drift);
      // Exit (scroll: top -> top+height): section is pinned, so the gentle drift
      // is applied directly as the next section climbs over it.
      const backgroundExit = centerOffset - drift * height;

      const backgroundKeyframes = [
        {
          transform: 'translate3d(0,' + backgroundEnter.toFixed(2) + 'px,0)',
          offset: toFraction(top - viewportHeight)
        },
        {
          transform: 'translate3d(0,' + centerOffset.toFixed(2) + 'px,0)',
          offset: toFraction(top)
        },
        {
          transform: 'translate3d(0,' + backgroundExit.toFixed(2) + 'px,0)',
          offset: toFraction(top + height)
        }
      ];

      entry.backgroundAnimation = entry.background.animate(backgroundKeyframes, {
        timeline: timeline,
        fill: 'both',
        easing: 'linear'
      });
    }

    if (entry.contentNodes.length) {
      let contentThreshold = 0;
      if (!entry.immediate) {
        contentThreshold = height - viewportHeight;
        if (contentThreshold < 0) {
          contentThreshold = 0;
        }
      }

      const contentKeyframes = [
        {
          transform: 'translate3d(0,0,0)',
          offset: toFraction(top)
        }
      ];

      if (contentThreshold > 0) {
        contentKeyframes.push({
          transform: 'translate3d(0,0,0)',
          offset: toFraction(top + contentThreshold)
        });
      }

      contentKeyframes.push({
        transform:
          'translate3d(0,' + (-viewportHeight).toFixed(2) + 'px,0)',
        offset: toFraction(top + height)
      });

      entry.contentAnimations = entry.contentNodes.map(function (contentNode) {
        return contentNode.animate(contentKeyframes, {
          timeline: timeline,
          fill: 'both',
          easing: 'linear'
        });
      });
    }
  }

  // Mobile within-frame parallax for stacked mobile-unit sections. The block
  // (entry.background's parent) scrolls up the screen at content speed; the image
  // inside it pans the opposite way at MOBILE_MEDIA_LAG so its net screen speed is
  // a touch slower than the card. Centered in its frame at the moment the frame is
  // centered in the viewport. Compositor-driven (ScrollTimeline) for smoothness.
  function bindMobileMediaDrift(entry, viewportHeight, maxScroll, timeline) {
    clearAnimations(entry);
    if (!entry.background || !entry.background.parentElement) {
      return;
    }

    const frame = entry.background.parentElement;
    const frameTop = documentTop(frame);
    const frameHeight = frame.offsetHeight || viewportHeight;
    // Scroll position at which the frame sits centered in the viewport.
    const centerScroll = frameTop + frameHeight / 2 - viewportHeight / 2;
    const panRoom = MOBILE_MEDIA_HEADROOM;
    // Scroll distance needed to pan a full `panRoom` at the lag rate.
    const panScrollSpan = panRoom / MOBILE_MEDIA_LAG;
    const toFraction = function (scrollPosition) {
      return scrollFraction(scrollPosition, maxScroll);
    };

    entry.backgroundAnimation = entry.background.animate(
      [
        {
          transform: 'translate3d(0,' + (-panRoom).toFixed(2) + 'px,0)',
          offset: toFraction(centerScroll - panScrollSpan)
        },
        {
          transform: 'translate3d(0,0,0)',
          offset: toFraction(centerScroll)
        },
        {
          transform: 'translate3d(0,' + panRoom.toFixed(2) + 'px,0)',
          offset: toFraction(centerScroll + panScrollSpan)
        }
      ],
      {
        timeline: timeline,
        fill: 'both',
        easing: 'linear'
      }
    );
  }

  function updateJsScrollNeeded() {
    jsScrollNeeded =
      !supportsScrollTimeline() ||
      (mobileMediaQuery.matches &&
        sectionEntries.some(function (entry) {
          return entry.mobileUnit;
        }));
  }

  function collect() {
    sectionEntries.forEach(clearAnimations);
    // New element set — force the next measure() to (re)build animations.
    lastBindSignature = null;

    const sections = Array.prototype.slice.call(
      document.querySelectorAll('.shopify-section.venture-section')
    );

    sectionEntries = sections
      .map(function (sectionElement) {
        const background = sectionElement.querySelector('.venture-stack__bg');
        const contentNodes = Array.prototype.slice.call(
          sectionElement.querySelectorAll('.venture-stack__content')
        );
        if (!background && !contentNodes.length) {
          return null;
        }

        let strength = background
          ? parseFloat(background.getAttribute('data-parallax-strength'))
          : NaN;
        if (isNaN(strength)) {
          strength = 30;
        }

        // Immediate: content scrolls up the moment the section pins, instead of
        // holding until the next section's edge enters.
        const immediate = contentNodes.some(function (contentNode) {
          return contentNode.classList.contains('venture-stack__content--immediate');
        });

        // Optional single element that travels as one unit on mobile (see above).
        const mobileUnit = sectionElement.querySelector('.venture-stack__mobile-unit');

        return {
          element: sectionElement,
          background: background,
          contentNodes: contentNodes,
          mobileUnit: mobileUnit,
          immediate: immediate,
          drift: (strength / 100) * DRIFT_SCALE,
          top: 0,
          height: 1,
          backgroundHeight: 0,
          backgroundAnimation: null,
          contentAnimations: null,
          lastUnitOffsetY: null
        };
      })
      .filter(Boolean);

    updateJsScrollNeeded();
  }

  function measure() {
    // A pinned sticky element's offsetTop reports its current position, not its
    // flow position. Un-stick all sections so offsetTop reads true flow offsets,
    // then restore in the same synchronous pass (no repaint of the un-stuck state).
    sectionEntries.forEach(function (entry) {
      entry.element.style.position = 'static';
    });
    sectionEntries.forEach(function (entry) {
      entry.top = documentTop(entry.element);
      entry.height = entry.element.offsetHeight || 1;
      entry.backgroundHeight = entry.background
        ? entry.background.offsetHeight || entry.height
        : 0;
      entry.lastUnitOffsetY = null;
    });
    sectionEntries.forEach(function (entry) {
      entry.element.style.position = '';
    });

    if (supportsScrollTimeline()) {
      const viewportHeight = window.innerHeight;
      const maxScroll = getMaxScroll();
      const timeline = getScrollTimeline();

      // Only rebuild the compositor animations when the geometry they depend on
      // has actually changed; otherwise leave the running animations untouched.
      const signature =
        viewportHeight +
        ':' +
        maxScroll +
        ':' +
        (mobileMediaQuery.matches ? 'm' : 'd') +
        ':' +
        sectionEntries
          .map(function (entry) {
            return entry.top + ',' + entry.height + ',' + entry.backgroundHeight;
          })
          .join('|');

      if (signature !== lastBindSignature) {
        lastBindSignature = signature;
        sectionEntries.forEach(function (entry) {
          if (mobileMediaQuery.matches && entry.mobileUnit) {
            // Stacked mobile layout: pan the media image inside its frame; the
            // 1:1 block climb is handled separately by applyMobileUnits().
            bindMobileMediaDrift(entry, viewportHeight, maxScroll, timeline);
            return;
          }
          bindScrollAnimations(entry, viewportHeight, maxScroll, timeline);
        });
      }
    } else {
      sectionEntries.forEach(clearAnimations);
    }

    updateJsScrollNeeded();
    apply();
  }

  function applyJsFallback() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const viewportHeight = window.innerHeight;
    const isMobile = mobileMediaQuery.matches;

    sectionEntries.forEach(function (entry) {
      // Progress past the pin: <0 climbing in, 0 pinned, >0 being covered.
      const rawProgress = scrollTop - entry.top;
      let progress = rawProgress;
      if (progress < 0) {
        progress = 0;
      } else if (progress > entry.height) {
        progress = entry.height;
      }

      // Mobile unit mode: the whole section moves as one block at scroll speed
      // over a fixed backdrop (no separate bg drift). The only effect is the
      // smooth 1:1 scroll while the next section climbs over it.
      if (isMobile && entry.mobileUnit) {
        const unitOffsetY = -progress;
        if (unitOffsetY !== entry.lastUnitOffsetY) {
          entry.lastUnitOffsetY = unitOffsetY;
          entry.mobileUnit.style.transform =
            'translate3d(0,' + unitOffsetY.toFixed(2) + 'px,0)';
        }
        return;
      }

      // Desktop (or no mobile unit): clear any leftover mobile-unit transform.
      if (entry.mobileUnit && entry.lastUnitOffsetY !== 0) {
        entry.lastUnitOffsetY = 0;
        entry.mobileUnit.style.transform = '';
      }

      // Exit: content scrolls up 1:1 with the covering section. Coupled (default)
      // holds until the next section's edge enters (after scrolling
      // height - viewport past the pin); immediate starts right at the pin.
      let contentThreshold = 0;
      if (!entry.immediate) {
        contentThreshold = entry.height - viewportHeight;
        if (contentThreshold < 0) {
          contentThreshold = 0;
        }
      }
      let contentTravel = progress - contentThreshold;
      if (contentTravel < 0) {
        contentTravel = 0;
      }

      const contentOffsetY = -contentTravel;
      if (entry.contentNodes.length) {
        const contentTransform =
          'translate3d(0,' + contentOffsetY.toFixed(2) + 'px,0)';
        entry.contentNodes.forEach(function (contentNode) {
          contentNode.style.transform = contentTransform;
        });
      }

      if (entry.background) {
        // Same model as the compositor path: gentle constant-speed drift,
        // centered in the viewport at the pin (centerOffset accounts for the
        // background being taller than the viewport).
        let centerOffset =
          (viewportHeight - (entry.backgroundHeight || viewportHeight)) / 2;
        if (centerOffset > 0) {
          centerOffset = 0;
        }
        let backgroundOffsetY;
        if (rawProgress >= 0) {
          backgroundOffsetY = centerOffset - entry.drift * progress;
        } else {
          let backgroundEntrance = rawProgress;
          if (backgroundEntrance < -viewportHeight) {
            backgroundEntrance = -viewportHeight;
          }
          backgroundOffsetY = centerOffset + backgroundEntrance * (1 - entry.drift);
        }
        entry.background.style.transform =
          'translate3d(0,' + backgroundOffsetY.toFixed(2) + 'px,0)';
      }
    });
  }

  function applyMobileUnits() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

    sectionEntries.forEach(function (entry) {
      if (!entry.mobileUnit) {
        return;
      }

      const rawProgress = scrollTop - entry.top;
      let progress = rawProgress;
      if (progress < 0) {
        progress = 0;
      } else if (progress > entry.height) {
        progress = entry.height;
      }

      const unitOffsetY = -progress;
      if (unitOffsetY !== entry.lastUnitOffsetY) {
        entry.lastUnitOffsetY = unitOffsetY;
        entry.mobileUnit.style.transform =
          'translate3d(0,' + unitOffsetY.toFixed(2) + 'px,0)';
      }
    });
  }

  function apply() {
    scrollFrameQueued = false;

    if (!jsScrollNeeded) {
      return;
    }

    if (supportsScrollTimeline()) {
      applyMobileUnits();
      return;
    }

    applyJsFallback();
  }

  function onScroll() {
    if (!jsScrollNeeded) {
      return;
    }
    if (!scrollFrameQueued) {
      scrollFrameQueued = true;
      window.requestAnimationFrame(apply);
    }
  }

  // Coalesce re-measures into a single frame. Pin offsets (`entry.top`) shift as
  // images/videos above each section finish loading, so we must re-measure
  // after load and on any layout change — not just on resize. Without this the
  // first measure runs against pre-media heights and the parallax is
  // miscalibrated (most visible on mobile, where there is no resize to correct it).
  function scheduleMeasure() {
    if (measureScheduled) {
      return;
    }
    measureScheduled = true;
    window.requestAnimationFrame(function () {
      measureScheduled = false;
      measure();
    });
  }

  function bind() {
    if (listenersBound) {
      return;
    }
    listenersBound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', scheduleMeasure, { passive: true });
    window.addEventListener('load', scheduleMeasure);
    // Crossing the mobile breakpoint swaps compositor animations vs mobile-unit JS.
    mobileMediaQuery.addEventListener('change', scheduleMeasure);
    if (typeof ResizeObserver !== 'undefined') {
      // Fires whenever the page height changes (late media, font swaps, etc.).
      const resizeObserver = new ResizeObserver(scheduleMeasure);
      resizeObserver.observe(document.documentElement);
    }
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    collect();
    if (!sectionEntries.length) {
      return;
    }
    bind();
    measure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Already loaded (e.g. theme editor re-render); defer so inline scripts run.
    window.setTimeout(init, 0);
  }

  // Re-collect when the theme editor swaps a section in/out. bind() is
  // idempotent, so listeners are never stacked.
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(init, 0);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
